export default "__VITE_PUBLIC_ASSET__cfda0bfd__"